

/**
 * Sets an item in localStorage with an expiration time.
 * @param {string} key - The key under which the value is stored.
 * @param {any} value - The value to store.
 * @param {number} ttl - Time-to-live in milliseconds.
 */

export const setWithExpiry = (key, value, ttl) => {
  try {
    const item = {
      value,
      expiry: Date.now() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    if (error.name === 'QuotaExceededError') {
      console.error(`[CacheUtils] Storage quota exceeded for key: ${key}`);
      clearOldestCacheItem();
      setWithExpiry(key, value, ttl); // Retry setting the item after clearing space
    } else {
      console.error(`[CacheUtils] Error setting cache for key: ${key}`, error);
    }
  }
};

export const syncPortfolioToLocalStorage = (portfolio, cacheDuration) => {
    try {
      localStorage.setItem('portfolio', JSON.stringify(portfolio));
      localStorage.setItem('portfolioExpiration', Date.now() + cacheDuration);
    } catch (error) {
      if (error.name === 'QuotaExceededError') {
        console.warn('Local storage limit exceeded. Clearing old cache.');
        clearOldestCacheItem();
        syncPortfolioToLocalStorage(portfolio, cacheDuration);
      } else {
        console.error('Error syncing portfolio to local storage:', error);
      }
    }
  };
  
  
/**
 * Retrieves an item from localStorage if it hasn't expired.
 * @param {string} key - The key of the item to retrieve.
 * @returns {any|null} - The retrieved value or null if expired or not found.
 */
export const getWithExpiry = (key) => {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (error) {
    console.error(`[CacheUtils] Error retrieving cache for key: ${key}`, error);
    return null;
  }
};

/**
 * Clears the oldest cache item in localStorage.
 */
const clearOldestCacheItem = () => {
  const keys = Object.keys(localStorage);
  let oldestKey = null;
  let oldestExpiry = Infinity;

  keys.forEach((key) => {
    try {
      const itemStr = localStorage.getItem(key);
      const item = JSON.parse(itemStr);
      if (item && item.expiry && item.expiry < oldestExpiry) {
        oldestExpiry = item.expiry;
        oldestKey = key;
      }
    } catch (error) {
      // Ignore parsing errors
    }
  });

  if (oldestKey) {
    localStorage.removeItem(oldestKey);
    console.log(`[CacheUtils] Removed oldest cache item: ${oldestKey}`);
  }
};
